import { configureStore } from '@reduxjs/toolkit';
import userReducer from "./slices/userSlice";
import districtsReducer from "./slices/districtsSlice"
export const store = configureStore({
    reducer: {
        user: userReducer,
        districts: districtsReducer
    }
});
